import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Broker, Platform } from '@c4/core';

import { SysmanComponentBase,IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, VersionsService } from '../services';

@Component({
  selector: 'sysman-package-versions',
  templateUrl: './sysman-package-versions.component.html',
  styleUrls: ['./sysman-package-versions.component.less']
})
export class SysmanPackageVersionsComponent extends SysmanComponentBase implements OnInit,IOnBrokerConnectedInit {

  showErrorMsg: boolean;
  allPackages: Array<any>;

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute, 
              private broker: Broker, private platform: Platform, 
              private connectedDeviceService: ConnectedDeviceService,
              protected versionsService: VersionsService) { 

    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init
    
    this.showErrorMsg = false;
    this.allPackages = [];

    this.store.select(s => s.versions).subscribe(
        v => {
            if (v) {
                let packages = [];
                for (var key in v.versions.versions) {
                  packages.push({name:key, version:v.versions.versions[key]});
                }
                if (packages.length == 0)
                  this.showErrorMsg = true;
                else
                  this.allPackages = packages.sort((a,b) => { if (a.name.toLowerCase() > b.name.toLowerCase()) return 1; if (b.name.toLowerCase() > a.name.toLowerCase()) return -1; return 0; });
                this.connectedDeviceService.setWorking(false);
            }
        });
  }

  ngOnInit() {
    super.OnInit();
    this.showErrorMsg = false;
    this.connectedDeviceService.setWorking(true);
  }
  
  ngOnDestroy() {
    super.destroy();
  }

  onBrokerConnectedInit() {
    this.connDevice.take(1).subscribe(conn => {
      this.versionsService.getAllVersions(conn.connectedDevice.address);
    });
  }

}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-package-versions/sysman-package-versions.component.ts